"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.init = exports.setup = void 0;
var interface_1 = require("./interface");
Object.defineProperty(exports, "setup", { enumerable: true, get: function () { return interface_1.setup; } });
Object.defineProperty(exports, "init", { enumerable: true, get: function () { return interface_1.init; } });
Object.defineProperty(exports, "getConfig", { enumerable: true, get: function () { return interface_1.getConfig; } });
//# sourceMappingURL=index.js.map